import styles from "css/pages/landing/LandingCurlySeparator.module.css";

export default function LandingCurlySeparator(): JSX.Element {
  return (
    <div className={styles.container}>
      <div className={styles.image} />
    </div>
  );
}
